const isEqualArrays = (
  firstArr: Array<any>,
  secondArr: Array<any>,
  strictMode = false
) =>
  strictMode
    ? firstArr?.length === secondArr?.length &&
      firstArr?.toString() === secondArr?.toString()
    : firstArr?.length === secondArr?.length &&
      firstArr?.sort()?.toString() === secondArr?.sort()?.toString();

export default isEqualArrays;
